import { PingSummaryModeType } from "../ts-types/SettingsTypes";

export const SOVSummaryMode: Record<PingSummaryModeType, PingSummaryModeType> =
  {
    MAPS: "MAPS",
    PAGE: "PAGE",
  };

export const AOAIntegrationSettings: Record<string, string> = {
  A: "About to request",
  N: "Not requested",
  C: "Locally cached",
  R: "Requested",
  G: "Locally cached failure",
  F: "Failed",
  S: "Skipped",
  U: "Untried",
};
